const FormatCurrency = new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN'
});


export default FormatCurrency;